module.exports = __webpack_public_path__ + "assets/4b1e9e30045718ebfc410211afc4a054.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/coins/bet_4.mp3
 ** module id = 41
 ** module chunks = 0
 **/